import { FieldError } from 'react-hook-form'

import { capitalize } from 'utils/formatters/baseFormatters'

export type ErrorInputProps = {
  error: boolean
  helperText?: string
}

export const errorTextToProps = (err?: string): ErrorInputProps => {
  const helperText = err ? capitalize(err.split('_')?.join(' ')) : undefined
  return {
    error: !!err,
    ...(helperText && { helperText }),
  }
}

export const extractInputError = (formError: FieldError | undefined) =>
  errorTextToProps(formError?.message?.toString() ?? undefined)
